/**
 * Utility function to convert URLs in text to clickable links
 * @param {string} text - The text that may contain URLs
 * @returns {JSX.Element} - React element with clickable links
 */
export const linkify = (text) => {
  if (!text) return text;

  const urlRegex =
    /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;

  const parts = text.split(urlRegex);

  const testRegex =
    /^(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}(?:\/[^\s]*)?)$/;

  return parts.map((part, index) => {
    if (part && testRegex.test(part)) {
      let href = part;
      if (!part.startsWith("http://") && !part.startsWith("https://")) {
        href = `https://${part}`;
      }

      return (
        <a
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#3b82f6",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {part}
        </a>
      );
    }
    return part;
  });
};
